import React from 'react';
import { Baby } from 'lucide-react';
import { ProgressBar } from './ProgressBar';
import { StatSection } from './StatSection';

interface AgeDistributionStatsProps {
  detalleEdad: {
    ninos: number;
    adolescentes: number;
    jovenes: number;
    adultosJovenes: number;
    adultos: number;
    adultosMayores: number;
  };
  totalMembers: number;
}

const ageColors = {
  ninos: '#60a5fa',        // Azul claro
  adolescentes: '#34d399', // Verde esmeralda
  jovenes: '#a78bfa',      // Púrpura
  adultosJovenes: '#fbbf24', // Ámbar
  adultos: '#f87171',      // Rojo coral
  adultosMayores: '#94a3b8' // Gris
};

export const AgeDistributionStats: React.FC<AgeDistributionStatsProps> = ({
  detalleEdad,
  totalMembers
}) => {
  const menoresDeEdad = detalleEdad.ninos + detalleEdad.adolescentes;
  const mayoresDeEdad = detalleEdad.jovenes + detalleEdad.adultosJovenes + detalleEdad.adultos + detalleEdad.adultosMayores;

  return (
    <StatSection title="Distribución Detallada por Rangos de Edad" icon={Baby} iconColor="text-purple-600">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div className="space-y-4">
          <h4 className="font-medium text-gray-700 mb-4">Clasificación por grupos etarios</h4>
          <ProgressBar
            label="Niños (0-12 años)"
            value={detalleEdad.ninos}
            total={totalMembers}
            color={ageColors.ninos}
          />
          <ProgressBar
            label="Adolescentes (13-17 años)"
            value={detalleEdad.adolescentes}
            total={totalMembers}
            color={ageColors.adolescentes}
          />
          <ProgressBar
            label="Jóvenes (18-25 años)"
            value={detalleEdad.jovenes}
            total={totalMembers}
            color={ageColors.jovenes}
          />
          <ProgressBar
            label="Adultos Jóvenes (26-35 años)"
            value={detalleEdad.adultosJovenes}
            total={totalMembers}
            color={ageColors.adultosJovenes}
          />
        </div>
        
        <div className="space-y-4">
          <h4 className="font-medium text-gray-700 mb-4">Adultos y Adultos Mayores</h4>
          <ProgressBar
            label="Adultos (36-50 años)"
            value={detalleEdad.adultos}
            total={totalMembers}
            color={ageColors.adultos}
          />
          <ProgressBar
            label="Adultos Mayores (51+ años)"
            value={detalleEdad.adultosMayores}
            total={totalMembers}
            color={ageColors.adultosMayores}
          />
          
          {/* Resumen visual */}
          <div className="mt-6 p-4 bg-gray-50 rounded-lg">
            <h5 className="text-xs font-medium text-gray-700 mb-3">Resumen por etapas</h5>
            <div className="grid grid-cols-2 gap-3">
              <div className="text-center p-3 bg-white rounded-lg shadow-sm">
                <div className="text-xs font-medium text-blue-500">
                  {menoresDeEdad.toLocaleString()}
                </div>
                <div className="text-xs text-gray-500">Menores de edad</div>
              </div>
              <div className="text-center p-3 bg-white rounded-lg shadow-sm">
                <div className="text-xs font-medium text-purple-500">
                  {mayoresDeEdad.toLocaleString()}
                </div>
                <div className="text-xs text-gray-500">Mayores de edad</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </StatSection>
  );
};

export default AgeDistributionStats;
